var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolicies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5034_817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.25 0H2.75C1.23 0 0 1.23 0 2.75V18.25C0 19.77 1.23 21 2.75 21H10.9C10.06 19.67 9.5 18.1 9.5 16.3V13.86C9.35 13.95 9.18 14 9 14H4C3.45 14 3 13.55 3 13C3 12.45 3.45 12 4 12H9C9.19 12 9.36 12.05 9.51 12.14C9.55 11.29 9.95 10.51 10.58 10H4C3.45 10 3 9.55 3 9C3 8.45 3.45 8 4 8H13C13.42 8 13.78 8.26 13.93 8.63L16.78 7.66C16.85 7.63 16.92 7.61 17 7.6V2.75C17 1.23 15.77 0 14.25 0ZM8 6H4C3.45 6 3 5.55 3 5C3 4.45 3.45 4 4 4H8C8.55 4 9 4.45 9 5C9 5.55 8.55 6 8 6Z",
    fill: "#DFA624"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.322 11.3392L18.072 9.55325C17.863 9.48225 17.636 9.48225 17.427 9.55325L12.177 11.3392C11.772 11.4772 11.499 11.8583 11.499 12.2863V16.3043C11.499 21.3713 17.118 23.8193 17.357 23.9213C17.483 23.9743 17.617 24.0003 17.75 24.0003C17.883 24.0003 18.017 23.9743 18.142 23.9203C18.381 23.8183 24 21.3713 24 16.3043V12.2863C24 11.8573 23.728 11.4772 23.322 11.3392ZM21.3 15.1003L18.3 19.1003C18.126 19.3323 17.861 19.4773 17.571 19.4973C17.547 19.4993 17.523 19.5003 17.5 19.5003C17.235 19.5003 16.981 19.3963 16.793 19.2073L14.793 17.2073C14.402 16.8163 14.402 16.1843 14.793 15.7933C15.184 15.4023 15.816 15.4023 16.207 15.7933L17.392 16.9783L19.7 13.9002C20.031 13.4592 20.658 13.3682 21.099 13.7002C21.542 14.0312 21.632 14.6583 21.3 15.1003Z",
    fill: "#DFA624"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5034_817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicies);
export default __webpack_public_path__ + "static/media/policies.accae0cc1817cd2d0a641b2197c97f9c.svg";
export { ForwardRef as ReactComponent };